import { FC } from 'react';
import 'twin.macro';
import 'styled-components/macro';

import { smileys } from './images';

export interface RatingProps {
  onSubmit: (score: number) => void;
}

export const Rating: FC<RatingProps> = ({ onSubmit }) => (
  <div tw="flex justify-between">
    {smileys.map(smiley => (
      <button key={smiley.score} className="group" tw="focus:outline-none" onClick={() => onSubmit(smiley.score)}>
        <img
          tw="transform transition-transform duration-fast ease-in-out group-hover:scale-125 group-focus:scale-125"
          src={smiley.image}
          alt={smiley.label}
        />
        <span tw="sr-only">{smiley.label}</span>
      </button>
    ))}
  </div>
);
